const celebrationInitialState = {
  data: null,
  loadStatus: 0,
};

function celebration2018Reducer(state = celebrationInitialState, action) {
  switch (action.type) {
    case 'LOAD_CELEBRATION2018': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_CELEBRATION2018_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        data,
      };
    }

    default:
      return state;
  }
}
export default celebration2018Reducer;
